import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { fetchUserCreditHistory } from '../../../../../Redux/Slices/userManagementSlice';
import CreditPointsCard from 'Components/UserManagement/ViewUser/CreditHistory';
import './styles.scss';

function CreditHistory() {  
    const {id} = useParams();
    const dispatch = useDispatch();
    const [creditData, setCreditData] = useState([]);
    const [balanceData, setBalanceData] =useState({});

    useEffect(()=>{
        dispatch(
            fetchUserCreditHistory({
                data:{id},
                callBack: getCreditCB,
            })
        )
    },[])

    const getCreditCB = (value) => {
        console.log(value?.data?.balanceData)
        setCreditData(value?.data?.data)
        setBalanceData(value?.data?.balanceData)
    }
 
    return (
        <div className="user-profile-details-credit">
            <div className="view-user-credit-container-header">
                <h2>Credit History</h2>
                <h3>Credit Balance: {balanceData?.no_of_credit}</h3>
            </div>

            <hr style={{ backgroundColor: "#E6E6E6" }} />

            <div className='user-profile-details-card'>
                {creditData?.length > 0 
                ? creditData.map((list,index) => {
                    return(
                        <CreditPointsCard 
                        date={new Date(list.createdAt).toLocaleDateString('en-GB')}
                        title={list.comments}
                        score={list.credit_spend}
                        /> 
                    )
                }) : "No Data"}

            </div>

        </div>
    );
}

export default CreditHistory;
